import React from "react"
import "./styles/styles.css"
import Cards from "./components/Cards"
import Header from "./components/SampleHeader"
import { HashRouter as Router, Switch, Route } from "react-router-dom"
import ObFaq from "./components/OBGettingStartedPage/ObFaq"
import Layout from "./components/Layout/Layout"
import Landing from "./components/OBGettingStartedPage/Landing"
import HelpDesk from "./components/OBGettingStartedPage/HelpDesk"
import Guides from "./components/OBGettingStartedPage/Guides"
import SubmitForm from "./components/OBGettingStartedPage/SubmitForm"
import QuickstartGuide from "./components/OBGettingStartedPage/QuickstartGuide"
import ProductDocumentation from "./components/OBGettingStartedPage/ProductDocumentation"
import ApiReference from "./components/OBGettingStartedPage/ApiReference"
import TrainingGuide from "./components/OBGettingStartedPage/TrainingGuide"
function App() {
  return (
    <>
      <Layout>
        <Router>
          <Switch>
            <Route exact path={`/`} component={HelpDesk} />
            <Route path={`/home`} component={Landing} />
            <Route path={`/onebill-faq`} component={ObFaq} />
            <Route path={`/onebill-Reference`} component={Guides} />
            <Route path={`/onebill-support`} component={SubmitForm} />
            <Route path={`/onebill-quickstart`} component={QuickstartGuide} />
            <Route
              path={`/onebill-product-documentation`}
              component={ProductDocumentation}
            />
            <Route path={`/onebill-api-reference`} component={ApiReference} />
            <Route path={`/onebill-training-guide`} component={TrainingGuide} />
          </Switch>
        </Router>
      </Layout>
    </>
  )
}

export default App
